<div class="row mb-3" *ngIf="monthForm != null" [formGroup]="monthForm">
  <div class="col-12">
    <div class="w-100 d-flex justify-content-between">
      <div>
        <span class="me-3">Check Dates</span>
        <lib-month-picker
          [minimumValue]="oldestReportDate"
          [maximumValue]="mostRecentReportDate"
          formControlName="month"></lib-month-picker>
      </div>
      <button
        (click)="download()"
        class="btn btn-primary"
        [disabled]="chosen == null || chosen.filenames.length == 0">
        Download Selected
      </button>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    @for (report of reports; track report; let i = $index) {
      <div ngbAccordion #parentAccordion="ngbAccordion">
        <div
          ngbAccordionItem
          ngbAccordionItem="accItemName"
          #accItemName="ngbAccordionItem"
          [collapsed]="i > 0">
          <div class="row">
            <div class="col-1">
              <button
                (click)="parentAccordion.toggle('accItemName'); closeOtherAccordions(i)"
                class="btn btn-link btn-sm p-0"
                title="report">
                <span
                  [className]="
                    !accItemName.collapsed ? 'collapse-icon open me-0' : 'collapse-icon me-0'
                  "></span>
              </button>
            </div>
            <div class="col-3">
              <span>Check Date: {{ report.Checkdate | date: 'MM/dd/yyyy' }}</span
              ><br />
              <small
                >Approved by {{ report.ProcessedBy }} on
                {{ report.ProcessedOn | date: 'MM/dd/yyyy' }} at
                {{ report.ProcessedOn | date: 'shortTime' }}</small
              >
            </div>
            <div class="col-2">
              <span>Period End: {{ report.PeriodEndDate | date: 'MM/dd/yyyy' }}</span>
            </div>
            <div class="col-2">Pay Type: {{ report.PayType }}</div>
            <div class="col-2">
              <span>Reference Number: {{ report.SequenceNumber }}</span>
            </div>
            <div class="col-2">
              <span>Frequency: {{ report.Frequency }}</span>
            </div>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody class="pl-4">
              <ng-template>
                <lib-report-selector
                  *ngIf="report.Reports != null && report.Reports.length > 0; else elseBlock"
                  (selectedReports)="selectionChanged(report, $event)"
                  [reports]="report.Reports"></lib-report-selector>
                <ng-template #elseBlock>No reports available for this checkdate.</ng-template>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    } @empty {
      <span>There are no reports available for this period.</span>
    }
  </div>
</div>
